module.exports = __webpack_public_path__ + "img/LogoMovistar02.774b4753.png";